const objetoGrupo = {
    "grupos": [
        {
            "nome": "Acácio",
            "idsGia": [
                34,
                78,
                113,
                166,
                177,
                224,
                231,
                240,
                256,
                258,
                266,
                289,
                294,
                306,
                311,
                316,
                318,
                321,
                340,
                342,
                355,
                356,
                380,
                383,
                409,
                410,
                422,
                423
            ]
        },
        {
            "nome": "Adinan",
            "idsGia": [
                185,
                310,
                350,
                428
            ]
        },
        {
            "nome": "Alexandre",
            "idsGia": [
                372,
                381,
                386,
                391,
                392,
                395,
                396,
                397,
                398,
                399,
                406,
                430,
                431
            ]
        },
        {
            "nome": "André",
            "idsGia": [
                94,
                157,
                270,
                297
            ]
        },
        {
            "nome": "Boxifarma",
            "idsGia": [
                287,
                390,
                404
            ]
        },
        {
            "nome": "Carina",
            "idsGia": [
                246,
                247
            ]
        },
        {
            "nome": "Celito",
            "idsGia": [
                186,
                187,
                338,
                370,
                371,
                427
            ]
        },
        {
            "nome": "Claver",
            "idsGia": [
                22,
                23,
                25,
                121
            ]
        },
        {
            "nome": "Cristian(Far 24 Horas)",
            "idsGia": [
                300,
                353
            ]
        },
        {
            "nome": "Daniel(Fcia De Luca)",
            "idsGia": [
                147,
                319
            ]
        },
        {
            "nome": "Diego",
            "idsGia": [
                148,
                149,
                150,
                164,
                272,
                327,
                384,
                385,
                393,
                412
            ]
        },
        {
            "nome": "Eduarda",
            "idsGia": [
                144,
                298
            ]
        },
        {
            "nome": "Eduardo",
            "idsGia": [
                367,
                368,
                369
            ]
        },
        {
            "nome": "Farmaléo",
            "idsGia": [
                123,
                124,
                125,
                126,
                260,
                299,
                401,
                402
            ]
        },
        {
            "nome": "Farma Vida",
            "idsGia": [
                172,
                174,
                175
            ]
        },
        {
            "nome": "Giotto",
            "idsGia": [
                83,
                84,
                85,
                86
            ]
        },
        {
            "nome": "Guilherme",
            "idsGia": [
                32,
                196,
                286,
                444
            ]
        },
        {
            "nome": "Hospitalar",
            "idsGia": [
                243,
                263
            ]
        },
        {
            "nome": "Junior(Cocal)",
            "idsGia": [
                142,
                349
            ]
        },
        {
            "nome": "Junior(Otacílio)",
            "idsGia": [
                331,
                332,
                333
            ]
        },
        {
            "nome": "Cosmetic",
            "idsGia": [
                82,
                403
            ]
        },
        {
            "nome": "IbiraFarma",
            "idsGia": [
                314,
                417
            ]
        },
        {
            "nome": "Robinho",
            "idsGia": [
                119,
                120,
                131
            ]
        },
        {
            "nome": "Santo Anjo ",
            "idsGia": [
                105,
                107,
                108
            ]
        },
        {
            "nome": "Uandreson ",
            "idsGia": [
                216,
                217,
                219
            ]
        },
        {
            "nome": "Vanfarma ",
            "idsGia": [
                152,
                153
            ]
        }
    ]
}
export default objetoGrupo;